import React, { useEffect, useState } from "react";
import { supabase } from "../../supabase";
import "./AdminPanel.css";

function LoginModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      onClose();
    }
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="admin__overlay" onClick={handleOverlayClick}>
      <div className="admin__panel">
        <div className="admin__header">
          <h3>Login</h3>
          <button className="admin__logout" onClick={onClose}>
            <i className="uil uil-times"></i>
          </button>
        </div>

        <form className="admin__form" onSubmit={handleLogin}>
          <label className="admin__label">Email</label>
          <input
            className="admin__input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
          />
          <label className="admin__label">Password</label>
          <input
            className="admin__input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <button className="admin__btn" type="submit" disabled={loading}>
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        {error && <p className="admin__error">{error}</p>}
      </div>
    </div>
  );
}

export default LoginModal;
